import TableDataCell from "./TableDataCell";

export default TableDataCell;
